import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import BraintreeForm from 'common/containers/braintree_form';
import AnimatedButton from 'common/components/animated_button';

/**
 * Modal wrapping Braintree form component.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class BraintreeFormModal extends Component {
  constructor(props) {
    super(props)

    this.state = {submitting: false, error: ''}

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.handleError = this.handleError.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  handleSuccess() {
    this.onClose()
  }

  handleError(err) {
    this.setState({submitting: false, error: err})
  }

  handleSubmit() {
    this.setState({submitting: true, error: ''})
    this.refs.braintree_form.getWrappedInstance().submit()
  }

  onClose() {
    this.setState({submitting: false, error: ''})
    this.props.onClose()
  }

  render() {
    const {showing} = this.props;
    const {submitting, error} = this.state;

    const primaryComponent = (
      <AnimatedButton processing={submitting} label="Save" processingLabel="Saving..."
        onClick={this.handleSubmit} errorMsg={error} successMsg="Done!"/>
    );

    return (
      <ModalDialog
        modalOpen={showing}
        modalHeader="Payment Methods"
        dialogClasses="braintree-form-modal"
        primaryComponent={primaryComponent}
        onSecondary={this.onClose}
        secondaryLabel="Cancel"
        closeAction={this.onClose}>

        <h2>Add payment method</h2>

        <BraintreeForm ref="braintree_form" onError={this.handleError}
          onSuccess={this.handleSuccess}/>

      </ModalDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./common/components/modal/braintree_form_modal.jsx